<template>
  <div class="min-h-screen relative text-secondary bg-gray-100">
    <nav
      class="border-b border-secondary sticky top-0 md:top-[110px] bg-white z-30"
    >
      <div class="center w-full sm:w-5/6">
        <NavBar class="h-12 md:h-16" />
      </div>
    </nav>
    <transition :duration="1200" mode="out-in" name="page">
      <RouterView class="pb-24 z-30" />
    </transition>

    <footer class="bg-white shadow bottom-0 absolute w-full">
      <div
        class="center py-6 text-gray-500 flex items-center justify-end text-sm"
      >
        {{ $t("footer") }}
        <a
          href="https://www.onetandem.com/es/index.html?utm_source=clientweb&utm_medium=clientweb&utm_campaign=popcouncil2021"
          target="_blank"
          class="flex items-center"
        >
          <img
            :src="`${publicPath}img/ot-logo.jpg`"
            class="ml-2 h-3 inline-block"
            alt="OneTandem"
        /></a>
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";

export default {
  components: {
    NavBar,
  },
  data() {
    return {
      publicPath: window.data_vis_uri || process.env.BASE_URL,
    };
  },
};
</script>
